import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationUserSearchCriteria extends ModelBase {
    public organisationName: string = "";

    public userName: string = "";
}